import { Button,  Input, InputGroup } from "@chakra-ui/react";
import Html5QrcodePlugin from "../../../components/Html5QrcodePlugin";
import Modal from "../../../components/Modal";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

interface IScanProductSerialNumbers {
    serialNumbers: string[];
    onSerialNumbersChange: (value: string[]) => void;
    validateSerialNumber?: boolean;
    validateFunction?: (serial: string) => Promise<boolean>;
}

const getEmptyStringsCount = (list: string[]) : number => {
    return list.reduce((a, c) => {
        if(c == "") {
            return a + 1;
        } else {
            return a;
        }
    }, 0);
}

const ScanProductSerialNumbers = (props: IScanProductSerialNumbers) => {
    const {
        serialNumbers,
        onSerialNumbersChange
    } = props;

    const { t } = useTranslation("translations");

    const [scanningModalOpen, setScanningModalOpen] = useState<boolean>(false);

    const [serialNumbersValidation, setSerialNumberValidation] = useState<{ [key:string]: boolean }[]>([]);
    
    // Run validation on every serial number
    useEffect(() => {
        (async () => {
        if (props.validateSerialNumber && props.validateFunction) {
            const tmp: { [key: string]: boolean }[] = [];

            for (const serial of serialNumbers) {
                if (serial === "") {
                    tmp.push({ [serial]: false });
                } else if (serial === Object.keys(serialNumbersValidation[serialNumbers.indexOf(serial)])[0]) {
                    tmp.push({ [serial]: serialNumbersValidation[serialNumbers.indexOf(serial)][serial] })
                } else {
                    tmp.push({ [serial]: await props.validateFunction(serial)});
                }
            }

            setSerialNumberValidation(tmp);
        }
        })()

    }, [serialNumbers, props.validateSerialNumber]);

    return (
        <div>
            <Button
                colorScheme="green"
                className="w-[95%] m-4"
                isDisabled={getEmptyStringsCount(serialNumbers) === 0}
                onClick={() => setScanningModalOpen(true)}
            >
                {t("START_SCANNING_SN")}
            </Button>

            <div className="w-[95%] m-4">
                {
                    serialNumbers.map((x: string, index: number) => (
                        <InputGroup
                            key={`serial_form_control_${index}`}
                            className="my-2"
                        >
                            <Input
                                isRequired
                                isInvalid={props.validateSerialNumber && serialNumbersValidation[index] ? !serialNumbersValidation[index][x] : false}
                                key={`serial_number_` + index}
                                value={x}
                                placeholder={t("PRODUCT_SERIAL_NUMBER") + " #" + (index + 1)}
                                onChange={(e) => {
                                    let tmp = [...serialNumbers];
                                    tmp[index] = e.target.value;
                                    onSerialNumbersChange([...tmp]);
                                }}
                            />
                        </InputGroup>
                    ))
                }
            </div>

            <Modal
                header={t("SCAN_SERIAL_NUMBERS_ONLY_X_LEFT") + " " + getEmptyStringsCount(serialNumbers)}
                isOpen={scanningModalOpen}
                onClose={() => setScanningModalOpen(false)}
            >
                <Html5QrcodePlugin
                    fps={5}
                    qrbox={250}
                    disableFlip={false}
                    verbose={true}
                    qrCodeSuccessCallback={(text, res) => {
                        const empty = getEmptyStringsCount(serialNumbers);

                        const index = serialNumbers.length - empty;
                        let tmp = [...serialNumbers];
                        tmp[index] = text;
                        onSerialNumbersChange([...new Set(tmp)]); // serial numbers are unique remove duplicates

                        // Close the modal if there are no more serial numbers to complete
                        if(getEmptyStringsCount(tmp) == 0)
                            setScanningModalOpen(false);
                    }}
                    qrCodeErrorCallback={(e) => { }}
                />
            </Modal>
        </div>
    )
}

export default ScanProductSerialNumbers;